import axios from "axios";

export const httpGet = axios.get;

export const httpPost = axios.post;

export const httpDelete = axios.delete;

export const httpPatch = axios.patch;

export const httpPut = axios.put;
